import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { aiOutputRequest } from "shared/actions/aiActions";
import { caseDetail } from "shared/actions/caseDetailActions";
import { slideDetail } from "shared/actions/slideDetailActions";

import ApplicationState from "store/ApplicationState";

import AIOutput from "../AIOutput";
import Layout from "../Layout";

const AIOutputPage = (_props: any) => {
  const { case_id, slide_id, classification_id } = useParams<{
    case_id: string;
    slide_id: string;
    classification_id: string;
  }>();

  const dispatch = useDispatch();

  useEffect(() => {
    const case_id_numeric = parseInt(case_id || "0");
    const slide_id_numeric = parseInt(slide_id || "0");
    if (case_id_numeric) {
      dispatch(caseDetail(case_id_numeric));
    }
    if (slide_id_numeric) {
      dispatch(slideDetail(slide_id_numeric));
    }
    if (classification_id) {
      dispatch(aiOutputRequest(classification_id));
    }
  }, [case_id, slide_id, classification_id, dispatch]);

  const caseDetailObject = useSelector(
    (state: ApplicationState) => state.caseDetail
  );
  const slideDetailObject = useSelector(
    (state: ApplicationState) => state.slideDetail
  );

  return (
    <Layout>
      <Helmet>
        <title>AI Output Page</title>
      </Helmet>
      <AIOutput
        caseDetailObject={caseDetailObject}
        slideDetailObject={slideDetailObject}
      />
      )
    </Layout>
  );
};

export default AIOutputPage;
